import { planTypes, BASE_PLAN_SUB_TYPES } from "@/common/constants";
import { pageConfig } from "@/common/service/page-config";
import modulesmap from './auto-scan';
import { getPlanTypeByCategory } from "@/common/service/parse";
import { softBundleUtils } from '@/views/config/soft-bundle/helper';

const moduleKeys = Object.values(modulesmap).map(x => x.key);

const type = pageConfig?.editConfig?.planType;
const baseType = getPlanTypeByCategory(pageConfig?.plan);
// const flow = pageConfig?.type;

const prioritize = (sorts = defSorts, priorities = [], removes = []) => {
    priorities = priorities.filter(x => planTypes[x]);
    return [...new Set([...priorities, ...sorts])].filter(x => !removes.includes(x));
};

const EVENTS_SESSIONS = [
    planTypes.EVENT_SAAS,
    planTypes.EVENT_SAAS_CORE,
    planTypes.ADDITIONAL_HOST,
    planTypes.ADDITIONAL_CO_EDITOR,
];

const PHONE = [
    planTypes.ZOOM_PHONE,
    planTypes.ZOOM_DEVICE,
    planTypes.ZOOM_DEVICE$DESK_PHONE,
    planTypes.ZOOM_DEVICE$HEADSET,
    planTypes.ZOOM_PHONE$ZPA,
    planTypes.ZOOM_PHONE$ZPI
];

const defSorts = prioritize(planTypes.map(moduleKeys), [
    planTypes.ZOOM_MEETING,
    planTypes.ZOOM_ONE_BUNDLE,
    planTypes.ZONE_PRO_PLUS,
    planTypes.MASTER_CLASS,
    ...EVENTS_SESSIONS,
    ...PHONE,
    planTypes.ZOOM_ENHANCED_MEDIA,
    planTypes.ZOOM_EMAIL_CALENDAR,
    planTypes.ZOOM_SCHEDULER,
    planTypes.CMR,
    planTypes.LARGE_MEETING,
    planTypes.TRANSLATION_CAPTIONS,
    planTypes.WEBINAR,
    planTypes.EVENT_SERVICES,
    planTypes.ZOOM_WHITEBOARD,
    planTypes.ZOOM_ROOMS,
    planTypes.TOLLFREE,
]);

const forProPlus = prioritize(defSorts, [
  planTypes.ZOOM_DEVICE,
  planTypes.ZOOM_DEVICE$DESK_PHONE,
  planTypes.ZOOM_DEVICE$HEADSET,
  planTypes.ZOOM_PHONE$ZPI,
  planTypes.ZOOM_PHONE$ADDITIONAL,
  planTypes.ZOOM_PHONE, // For campaign link validate/verify api param sort (pro plus calling plan needs to be added in front of pbx)
  planTypes.ZOOM_PHONE$ZPA,
  planTypes.WEBINAR,
  planTypes.LARGE_MEETING,
  planTypes.CMR,
  planTypes.ZOOM_SCHEDULER,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.TOLLFREE,
  planTypes.EVENT_SERVICES,
  planTypes.ZOOM_ONE_BUNDLE, // for pro plus upgrade to biz plus
])

const forProPlusSoftBundle = prioritize(defSorts, [
  planTypes.ZOOM_PHONE,
  planTypes.ZOOM_DEVICE,
  planTypes.ZOOM_DEVICE$DESK_PHONE,
  planTypes.ZOOM_DEVICE$HEADSET,
  planTypes.ZOOM_PHONE$ZPI,
  planTypes.ZOOM_PHONE$ADDITIONAL,
  planTypes.ZOOM_PHONE$ZPA,
  planTypes.WEBINAR,
  planTypes.LARGE_MEETING,
  planTypes.CMR,
  planTypes.ZOOM_SCHEDULER,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.TOLLFREE,
  planTypes.EVENT_SERVICES,
])

const forClinicalSoftBundle = [
  planTypes.ZOOM_ONE_BUNDLE,
  planTypes.ZOOM_PHONE,
  planTypes.ZOOM_PHONE$ZPA,
  planTypes.ZOOM_DEVICE,
  planTypes.ZOOM_DEVICE$DESK_PHONE,
  planTypes.ZOOM_DEVICE$HEADSET,
  planTypes.ZOOM_PHONE$ZPI,
  planTypes.ZOOM_PHONE$ADDITIONAL,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.CMR,
  planTypes.LARGE_MEETING,
  planTypes.WEBINAR,
  planTypes.EVENT_SERVICES,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.TOLLFREE,
  planTypes.ZOOM_SCHEDULER
]

const forBrickMortarSoftBundle = [
  planTypes.ZOOM_PHONE,
  planTypes.ZOOM_DEVICE,
  planTypes.ZOOM_DEVICE$DESK_PHONE,
  planTypes.ZOOM_DEVICE$HEADSET,
  planTypes.ZOOM_SCHEDULER,
  planTypes.ZOOM_PHONE$ZPI,
  planTypes.ZOOM_PHONE$ZPA,
  planTypes.ZOOM_MEETING,
]

const forPro = prioritize(defSorts, [
  planTypes.WEBINAR,
  planTypes.LARGE_MEETING,
  planTypes.ZOOM_SCHEDULER,
  planTypes.ZONE_PRO_PLUS,
  planTypes.ZOOM_PHONE,
  planTypes.CMR,
  planTypes.TRANSLATION_CAPTIONS,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.TOLLFREE
])

const forBiz = prioritize(defSorts, [
  planTypes.WEBINAR,
  planTypes.ZOOM_ONE_BUNDLE,
])

const forZoomDocs = prioritize(defSorts, [
  planTypes.ZOOM_MEETING,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.ZOOM_SCHEDULER,
  planTypes.ZOOM_PHONE,
]);

// this is for sort & filter
const getPriorities = (planType, planSubType) => [
    {
      for: () => softBundleUtils.hasCustomSorts(),
      sorts: softBundleUtils.getCustomSorts()
    },
    {
      for: () => softBundleUtils.isSoftProPlusBundle(), // for soft bundle pro plus
      sorts: forProPlusSoftBundle
    },
    {
      for: () => softBundleUtils.isClinical(),
      sorts: forClinicalSoftBundle
    },
    {
      for: () => softBundleUtils.isBrickMortar(),
      sorts: forBrickMortarSoftBundle
    },
    {
        for: () => pageConfig.init_categories && pageConfig.init_categories.length,
        sorts: prioritize(
            defSorts,
            (pageConfig.init_categories || '').split(';').map(c => getPlanTypeByCategory(c)).filter(Boolean)
        ),
    },
    {
      for: () => planType === planTypes.WEBINAR,
      sorts: prioritize(defSorts, [
        planTypes.WEBINAR,
        planTypes.EVENT_SERVICES,
        planTypes.ZOOM_MEETING,
        planTypes.ZOOM_ONE_BUNDLE,
        planTypes.ZONE_PRO_PLUS,
      ]),
    },
    {
      for: () => planType === planTypes.ZOOM_MEETING && planSubType === BASE_PLAN_SUB_TYPES.PRO,
      sorts: forPro,
    },
    {
      for: () => planType === planTypes.ZOOM_MEETING && planSubType === BASE_PLAN_SUB_TYPES.BIZ,
      sorts: forBiz,
    },
    {
        for: () => planType === planTypes.ZOOM_MEETING,
        sorts: prioritize(defSorts, [
            planTypes.MASTER_CLASS,
            planTypes.ZOOM_SCHEDULER,
            planTypes.LARGE_MEETING,
            planTypes.CMR,
        ]),
    }, {
        for: () => planType === planTypes.TOLLFREE && baseType !== planTypes.VIDEO_SDK,
        sorts: [
            planTypes.ZOOM_MEETING,
            planTypes.ZOOM_ONE_BUNDLE,
            planTypes.ZOOM_SCHEDULER,
            planTypes.CMR,
            planTypes.WEBINAR,
            planTypes.TOLLFREE$DID,
        ],
    }, {
        for: () => planType === planTypes.TOLLFREE && baseType === planTypes.VIDEO_SDK,
        sorts: [
            planTypes.VIDEO_SDK,
            planTypes.LDKCMR
        ],
    }, {
      for: () => planType === planTypes.ZONE_PRO_PLUS,
      sorts: forProPlus,
    }, {
      for: () => planType === planTypes.ZOOM_DOCS,
      sorts: forZoomDocs,
    }, {
        for: () => true,
        sorts: defSorts,
    }
];

const sorts = getPriorities(type, pageConfig?.editConfig?.category).find(x => x.for())?.sorts ?? [];

/**
 * get sorts by plan type and plan sub type
 * @param {string} planType
 * @param {string} planSubType
 * @returns
 */
export const getSortedTypes = (planType, planSubType) => {
  const types = getPriorities(planType, planSubType).find(x => x.for())?.sorts ?? [];
  return prioritize(types, [planType]);
}

export default prioritize(sorts, [type]); // always prioritize target plans
